import { Component } from '@angular/core';
import { ConfigurationService } from '@app/core/config/configuration.service';

@Component({
  templateUrl: './forbidden.component.html',
  standalone: false
})
export class ForbiddenComponent {
  private apiBase: string;

  constructor(private configurationService: ConfigurationService) {
    this.apiBase = configurationService.getConfig().awisaFOUrl;
  }
}
